import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/static/images/logo_uz.svg'


const _hoisted_1 = {
  id: "header",
  class: "o-container header"
}
const _hoisted_2 = { class: "header_logo" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "header_category"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contact_sticky = _resolveComponent("contact-sticky")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header_meta-nav o-container__remove" }, " ", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", { href: _ctx.startseite }, _cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "c-header__logo",
            alt: "Logo GEV",
            title: "Zur Startseite der GEV Versicherung"
          }, null, -1)
        ]), 8, _hoisted_3)
      ]),
      (_ctx.produkt)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.produkt) + " ", 1),
              (_ctx.zeigeFachbereich)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    (_ctx.piniaStore.state.isMakler)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Makler"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, "Direkt"))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "header_spacer o-container__remove" }, " ", -1))
    ]),
    _createVNode(_component_contact_sticky, {
      "is-makler": _ctx.piniaStore.state.isMakler
    }, null, 8, ["is-makler"])
  ], 64))
}